import { render, staticRenderFns } from "./PenInfo.vue?vue&type=template&id=8def1740&"
import script from "./PenInfo.vue?vue&type=script&lang=js&"
export * from "./PenInfo.vue?vue&type=script&lang=js&"
import style0 from "./PenInfo.vue?vue&type=style&index=0&id=8def1740&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports